import React from 'react';

const BreadcrumbsPlaceholder = () => {
  return (
    <div className="placeholder-breadcrumbs color-white">
      <div className="placeholder-row animation" />
    </div>
  );
};

export default BreadcrumbsPlaceholder;
